const debounce = require('throttle-debounce/debounce');
const moment = require('moment');
const templatePagination = require('./../pagination/pagination.ejs');
const qs = require('query-string');

if (getLang() == 'ru') {
	moment.locale('ru');
}

function queryString (params) {
	let url = window.location.pathname
	let keys = Object.keys(params)
	let string = ''

	if (Object.keys(params).length) {
		url += `?`
	}

	if (keys.length > 0) string = qs.stringify(params, {
		arrayFormat: 'bracket',
		sort: (a, b) => b - a
	})

	url += `${string}`

	if (history.pushState) {
		try {
			history.pushState({}, '', url)
			return
		} catch (err) {
			console.error('Error in queryString!')
		}
	} else {
		document.location.href = url
	}
}

class Component {
	constructor($container) {
		this.$container = $container;
		this.$body = this.$container.find('.component__body');
		this.$filterSelects = $('.component__select-filters');
		this.$filterTabs = this.$container.find('.component__tab-filters');
		this.$filterPagination = this.$container.find('.component__pagination');
		this.$search = this.$container.find('.component__search');
		this.queryParamTab = 'tab';
		this.queryParamPage = 'page';

		this.urlParams = {
			tab: 'all',
			page: 1
		}
	}

	parsedUrl() {
		return qs.parse(window.location.search);
	}

	getParams() {
		const paramsFromData = this.$container.data('static-params');
		const paramsCollect = {
			ajax: true,
			pageCurrent: this.$filterPagination.find(`.pagination__link--active`).data('filter-value'),
			dateYear: this.$filterSelects.find(`[data-filter-name="dateYear"]`).val(),
			dateMonth: this.$filterSelects.find(`[data-filter-name="dateMonth"]`).val(),
			rubric: this.$container.find('.tab-filters__link--active').data('filter-value'),
			search: this.$search.find('.w-search__input').val(),
			lang: getLang()
		};

		return Object.assign({}, paramsCollect, paramsFromData);
	}

	createPreloader() {
		this.$container
			.append($(`<div class="preloader">
						<div class="preloader__item"></div>
					</div>`));
	}

	triggerClick(e) {
		let value = $(e.target).data('trigger-id');

		this.$container
			.find(`[data-filter-value="${value}"]`)
			.trigger('click');
	}
	
	filterHandler(page) {
		if (page > 1) {
			this.sendRequest(false, page);
		} else {
			this.sendRequest();
		}
	}

	create() {
		const tab = this.parsedUrl()[this.queryParamTab];
		const page = parseInt(this.parsedUrl()[this.queryParamPage]);

		this.$filterSelects
			.on('change', '.js-component-filter', debounce(200, (e) => this.sendRequest()));
		this.$filterPagination
			.on('click', '.js-component-filter', debounce(200, (e) => {
				let first = (($(e.target)
								.closest('.pagination__item')
								.hasClass('pagination__item--prev') &&
								$(window).outerWidth() > 768) ?
								true :
								false
							);
				this.sendRequest(first);
			}));
		this.$filterTabs
			.on('click', '.js-component-filter', debounce(200, (e) => {
				this.sendRequest()
			}));
		this.$container
			.on('click', '.js-trigger-click', (e) => {
				e.preventDefault();
				this.triggerClick(e);
			});
		this.$search
			.find('.js-form')
			.on('submit', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.sendRequest();
				this.$search.find('.w-search__input').blur() //для скрытия клавиатуры на мобилке
			});
		this.$search
			.on('input', '.w-search__input', debounce(200, (e) => {
				this.sendRequest()
			}));

		this.createPreloader();

		if (tab || page) {
			this.filterHandler(page);
		} else {
			this.$body.css('opacity', '1' )
		}
	}

	sendRequest(firstLoad = true, page) {
		const self = this;
		const dataAjaxPath = self.$container.attr('data-ajax-path');
		const $preloader = self.$container.find('.preloader');
		const params = self.getParams();

		$preloader
			.velocity('stop')
			.velocity('transition.fadeIn');

		if (firstLoad) {
			params.pageCurrent = 1;
		}

		if (page) {
			params.pageCurrent = parseInt(page);
		}

		$.post(dataAjaxPath, params)
			.done(function (data) {
				let json = JSON.parse(data);

				if (json.page.total > 0) {
					self.$body
						.html(json.items);

					self.$container
						.attr('data-page-total', json.page.total)
						.attr('data-page-current', json.page.current);

					self.$filterPagination
						.html(templatePagination(json.page));

					this.urlParams = {
						tab: params.rubric,
						page: json.page.current
					}

					queryString(this.urlParams)

					if (json.page.total == 1) {
						self.$filterPagination
							.hide();
					} else {
						self.$filterPagination
							.show();
					}
				} else {
					self.$body
						.html(`<p class="empty-result">${json.msg.text}</p>`);

					self.$container
						.attr('data-page-total', 1)
						.attr('data-page-current', 1);

					self.$filterPagination
						.hide();
					
					self.urlParams = {
						tab: 'all',
						page: 1
					}

					queryString({})
				}

				self.$body.css('opacity', '1' )
			})
			.fail(function (data) {
				console.error('ajax request failed');
			})
			.always(function (data) {
				$preloader
					.velocity('stop')
					.velocity('transition.fadeOut');
			});
	}
}

if ($('.js-component').length) {
	let component = new Component($('.js-component'));
	component.create();
}



// WEBPACK FOOTER //
// ./frontend/components/component/component.js